export default {
	error_text:'Pojavila se je napaka',
	you:'Ja',
	is_calling_accept:'Agent opravi klic. Sprejmi',
	chat_initialized:'Klepet je aktiven',
	initializing_chat:'Začenjam klepet',
	chat:'Klepet',
	welcome: 'Dobrodošli',
	start_chat:'Začni klepet',
	start_chat_video: 'Začni video klic',
	start_chat_video_id: 'Naprej',
	name:'Ime in priimek',
	email:'E-naslov',
	telephone:'Mobilna telefonska št.',
	placeholder_name:'Vaše ime in priimek',
	placeholder_email:'xy@acme.com',
	placeholder_telephone:'+386 XX XXX XXX',
	placeholder_taxNumber:'XXXXXXXX',
	topic:'Tema',
	topic_nlb:'Naročilo/sprememba produkta',
	select_topic_nlb:'Izberi iz seznama',
	cancel:'Prekliči',
	send:'Pošlji',
	sent:'Poslano',
	minimize:'Smanji',
	end_chat:'Končaj',
  close: 'Zapri',
	entered_chat: 'Agent je vstopil v klepet',
	left_chat: 'Agent je zapustil klepet',
	HANDLED:'Pogovor je zaključen',
	MISSED:'Pogovor je zaključen',
	MISSED_QUEUE:'Vaše zahteve trenutno ne moremo obdelati, poskusite znova pozneje!',
	MISSED_PROCESSING:'Zaradi neaktivnosti je seja potekla. Če niste prejeli vseh informacij, nas ponovno kontaktirajte.',
	audio_input:'Mikrofon',
	audio_output:'Zvočnik',
	video_input: 'Kamera',
	invite_text: 'To je enkratna povezava za video klic. Ko se video klic začne, te povezave ne bo več mogoče uporabljati.',
	type_message: 'Prosim napišite sporočilo',
	survey_heading: 'Hvala vam',
	survey_subheading: 'Vaše mnenje nam veliko pomeni, zato vas prosimo za ispolnitev kratke ankete.',
	agree_with: 'Strinjam se s ',
	general_terms: 'splošnimi pogoji',
	con_satisfaction: 'Kako ste zadovoljni s pogovorom?',
	get_answers: 'Ali ste dobili odgovore na vaša vprašanja?',
	fully: 'V celoti',
	partially: 'Deloma',
	no_answer: 'Nisem dobila odgovora',
	recommend: 'Kako verjetno bi nas priporočili prijateljem ali znancem?',
	device_settings: 'Nastavitve naprave',
	show: 'Oddajte mnenje',
	not: 'Ne, hvala',
	start_survey: 'Ste bili s klicem zadovoljni?',
	call_start: 'Klic se je začel ',
	call_end: 'Klic končal',
	required_message: 'To polje je obvezno',
	required_tel_message: 'To polje je obvezno - primer +YYY XX XXX XXX',
	tel_format: 'npr. 068 555 1234',
	incorrect_email_format: 'Nepravilna oblika - primer xy@acme.com',
	topic_1: 'Krediti/Limiti',
	topic_2: 'PIN/Kartice/NLB Pay',
	topic_3: 'Plačila/Paketi',
	topic_4: 'NLB Klik',
	topic_5: 'NLB Proklik/Klikpro',
	topic_6: 'Ostale informacije',
	survey_field_1_label_info: 'Kako ste zadovoljni s komunikacijo in sodelovanjem z našimi agenti?',
	survey_field_2_label_info: 'Ali so bila vaša vprašanja v celoti odgovorjena?',
	survey_field_3_label_info: 'Kako verjetno je, da boste naše storitve priporočili prijatelju ali znancu?',
	bubble_txt1: 'Vas zanima naša ponudba?',
	bubble_txt2: 'Pogovorite se z našim agentom.',
	incoming_video_call: 'Dohodni video klic',
	incoming_call: 'Dohodni klic',
	invite_end_message: 'Hvala, ker ste se obrnili na nas!',
	invite_end_message2: 'Upamo, da smo vam danes uspeli pomagati. Če potrebujete dodatno pomoč, nas kontaktirajte. Imej lep dan!',
	expired_message: 'Klepet je potekel',
	microphone_not_detected: 'Mikrofon ni detektiran',
	camera_or_microphone_not_detected: 'Kamera ali mikrofon nista zaznana',
	system_default_speaker_device: 'Privzeta naprava za predvajanje zvoka',
	instructions_enable_media_setsinkid: 'Kliknite tukaj za navodila za seznam naprav za predvajanje zvoka',
	welcome_chat: 'Dobrodošli v klepetu',
	welcome_chat_video: 'Pozdravljeni v video klicu!',
	welcome_chat_video_id: 'Dobrodošli v video ID',
	close_settings: 'Zapri nastavitve',
	agent: 'Agent',
	enter_data: 'Prosimo, vnesite svoje podatke.',
	survey: 'Anketa',
	open_survey: 'Odpri anketo',
	submitted: 'Predloženo',
	chatbot: 'Chatbot',
	request_file_upload: 'Zatraži slanje datoteke',
	general_error: 'Error occurred. Pleas try again',
	file_max_size_exceeded: 'Dokument presega dovoljeno velikost. Dovoljena velikost: ',
	file_extension_not_allowed: 'Nepodprta oblika dokumenta. Podprti so: ',
	uploaded_file_message: 'Nova datoteka je bila naložena',
	next: 'Naprej',
	welcome_audio: 'Pozdravljeni v audio klicu!',
	start_audio: 'Začni audio klic',
	agent_busy: 'Agent je zauzet',
	agent_not_ready: 'Agent je trenutno nedostupan',
  comment: 'Komentar',
	submit: 'Nadaljuj',
	start_video_scan: 'Pokrenite video skeniranje',
	scan_document: "Zajem dokumenta",
	start: "Začni",
	finish_on_call_end: 'Pogovor je zaključen'
}